import ConfirmLogIn from './ConfirmLogIn'
export { ConfirmLogIn }
export default ConfirmLogIn
